import { countries } from 'countries-list';
import { City } from 'country-state-city';

const CONTINENTS_BY_LANGUAGE = {
  fr: [
    { code: 'AF', label: 'Afrique' },
    { code: 'EU', label: 'Europe' }
  ],
  en: [
    { code: 'AF', label: 'Africa' },
    { code: 'EU', label: 'Europe' }
  ],
  ar: [
    { code: 'AF', label: 'افريقيا' },
    { code: 'EU', label: 'اوروبا' }
  ]
};

const LOCALE_BY_LANGUAGE = {
  fr: 'fr-FR',
  en: 'en-US',
  ar: 'ar-MA'
};

const COUNTRY_ENTRIES = Object.entries(countries).map(([isoCode, data]) => ({
  isoCode,
  name: data.name,
  continent: data.continent,
  continents: data.continents || []
}));

const COUNTRY_NAME_LOOKUP = COUNTRY_ENTRIES.reduce((acc, country) => {
  acc[country.isoCode] = country.name;
  return acc;
}, {});

const citiesCache = new Map();

const belongsToContinent = (country, continentCode) => {
  if (!continentCode) return false;
  if (country.continent === continentCode) return true;
  return Array.isArray(country.continents) && country.continents.includes(continentCode);
};

const sortByLabel = (language) => (a, b) =>
  a.label.localeCompare(b.label, LOCALE_BY_LANGUAGE[language] || 'fr-FR', { sensitivity: 'base' });

export const getSupportedContinents = (language = 'fr') =>
  CONTINENTS_BY_LANGUAGE[language] || CONTINENTS_BY_LANGUAGE.fr;

export const getCountriesByContinent = (continentCode, language = 'fr') => {
  if (!continentCode) return [];
  return COUNTRY_ENTRIES
    .filter((country) => belongsToContinent(country, continentCode))
    .map((country) => ({ value: country.isoCode, label: country.name }))
    .sort(sortByLabel(language));
};

export const getCountryName = (isoCode) => COUNTRY_NAME_LOOKUP[isoCode] || '';

export const getCitiesByCountryCode = (isoCode, language = 'fr') => {
  if (!isoCode) return [];

  if (citiesCache.has(isoCode)) {
    return citiesCache.get(isoCode);
  }

  try {
    const cities = City.getCitiesOfCountry(isoCode)
      ?.map((city) => city.name)
      .filter(Boolean) || [];

    const uniqueCities = Array.from(new Set(cities)).sort((a, b) =>
      a.localeCompare(b, LOCALE_BY_LANGUAGE[language] || 'fr-FR', { sensitivity: 'base' })
    );

    citiesCache.set(isoCode, uniqueCities);
    return uniqueCities;
  } catch (error) {
    console.error('Failed to load cities for country', isoCode, error);
    citiesCache.set(isoCode, []);
    return [];
  }
};
